/**
 * © [2020] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import React, { useState } from 'react';
import TextField from '@material-ui/core/TextField';
import * as constantMessageData from '../../../../SharedModules/Errors/constantMessageData';

function CommentAddressInfoTab(props) {
  const {
    selectRowData,
    isSystemParameter,
    isEnablebyRole,
    handleOnChangeEvent,
    showEmailErr,
    showPhoneErr,
    showZip4Err,
    isReadOnly,
    errorMessages,
  } = props;
  const [windowWidth, setWindowWidth] = useState(window.screen.width);

  React.useEffect(() => {
    window.addEventListener('resize', textReplace);
  }, [windowWidth]);

  // Set lable text according to the screen width for Phone number
  const textReplace = () => {
    setWindowWidth(window.screen.width);
  };

  return (
    <div data-testid='addressInfo-tab'>
      <div className='tab-body custom-check mt-3'>
        <form autoComplete='off'>
          <div className=''>
            <fieldset className='custom-fieldset custom-height'>
              <legend>Contact Information</legend>

              <div className='form-wrapper'>
                <div className='mui-custom-form input-md'>
                  <TextField
                    id='corrName'
                    label='Name'
                    data-testid='name'
                    disabled={isReadOnly || !isEnablebyRole || isSystemParameter}
                    fullWidth
                    placeholder=''
                    inputProps={{ maxLength: 40 }}
                    InputLabelProps={{
                      shrink: true,
                    }}
                    value={selectRowData && selectRowData.corrName}
                    onChange={(e) => {
                      handleOnChangeEvent(e, 'corrName');
                    }}
                  />
                </div>
                <div className='mui-custom-form input-md'>
                  <TextField
                    id='corpName'
                    label='Corporation Name'
                    data-testid='Corporation-name'
                    disabled={isReadOnly || !isEnablebyRole || isSystemParameter}
                    fullWidth
                    placeholder=''
                    inputProps={{ maxLength: 45 }}
                    InputLabelProps={{
                      shrink: true,
                    }}
                    value={selectRowData && selectRowData.corpName}
                    onChange={(e) => {
                      handleOnChangeEvent(e, 'corpName');
                    }}
                  />
                </div>
                <div className='line-break-div' />
                <div className='mui-custom-form input-md'>
                  <TextField
                    id='Address Lines'
                    data-testid='Address-line'
                    label='Address Lines 1'
                    disabled={isReadOnly || !isEnablebyRole || isSystemParameter}
                    fullWidth
                    placeholder=''
                    inputProps={{ maxLength: 45 }}
                    InputLabelProps={{
                      shrink: true,
                    }}
                    value={selectRowData && selectRowData.addLine1}
                    onChange={(e) => {
                      handleOnChangeEvent(e, 'addLine1');
                    }}
                  />
                </div>
                <div className='mui-custom-form input-md'>
                  <TextField
                    id='addrLine2'
                    label='Address Lines 2'
                    data-testid='address-line2'
                    disabled={isReadOnly || !isEnablebyRole || isSystemParameter}
                    fullWidth
                    placeholder=''
                    inputProps={{ maxLength: 45 }}
                    InputLabelProps={{
                      shrink: true,
                    }}
                    value={selectRowData && selectRowData.addLine2}
                    onChange={(e) => {
                      handleOnChangeEvent(e, 'addLine2');
                    }}
                  />
                </div>
                <div className='mui-custom-form input-md'>
                  <TextField
                    id='addrLine3'
                    label='Address Lines 3'
                    data-testid='address-lines3'
                    disabled={isReadOnly || !isEnablebyRole || isSystemParameter}
                    fullWidth
                    placeholder=''
                    inputProps={{ maxLength: 45 }}
                    InputLabelProps={{
                      shrink: true,
                    }}
                    value={selectRowData && selectRowData.addLine3}
                    onChange={(e) => {
                      handleOnChangeEvent(e, 'addLine3');
                    }}
                  />
                </div>

                <div className='line-break-div' />
                <div className='mui-custom-form input-md'>
                  <TextField
                    id='city'
                    label='City'
                    data-testid='city'
                    disabled={isReadOnly || !isEnablebyRole || isSystemParameter}
                    fullWidth
                    placeholder=''
                    inputProps={{ maxLength: 30 }}
                    InputLabelProps={{
                      shrink: true,
                    }}
                    value={selectRowData && selectRowData.city}
                    onChange={(e) => {
                      handleOnChangeEvent(e, 'city');
                    }}
                  />
                </div>
                <div className='mui-custom-form input-md'>
                  <TextField
                    id='stateCD'
                    label='State'
                    data-testid='state'
                    disabled={isReadOnly || !isEnablebyRole || isSystemParameter}
                    fullWidth
                    placeholder=''
                    inputProps={{ maxLength: 2 }}
                    InputLabelProps={{
                      shrink: true,
                    }}
                    value={selectRowData && selectRowData.stateCD}
                    onChange={(e) => {
                      handleOnChangeEvent(e, 'stateCD');
                    }}
                  />
                </div>
                <div className='mui-custom-form input-md'>
                  <div className='row'>
                    <div className='col-sm-7 pr-0'>
                      <TextField
                        id='zip'
                        label='Zip'
                        data-testid='zip'
                        disabled={isReadOnly || !isEnablebyRole || isSystemParameter}
                        fullWidth
                        placeholder=''
                        inputProps={{ maxLength: 10 }}
                        InputLabelProps={{
                          shrink: true,
                        }}
                        value={selectRowData && selectRowData.zip}
                        onChange={(e) => {
                          handleOnChangeEvent(e, 'zip');
                        }}
                      />
                    </div>
                    <div className='col-sm-5'>
                      <TextField
                        id='Zip+4'
                        label='Zip+4'
                        data-testid='zip4'
                        className='mandate-fields'
                        disabled={isReadOnly || !isEnablebyRole || isSystemParameter}
                        fullWidth
                        placeholder=''
                        inputProps={{ maxLength: 4 }}
                        InputLabelProps={{
                          shrink: true,
                        }}
                        value={selectRowData && selectRowData.zip4}
                        onChange={(e) => {
                          handleOnChangeEvent(e, 'zip4');
                        }}
                        onBlur={(e) => {
                          props.handleOnBlurEvent(e, 'zip4');
                        }}
                        helperText={
                          showZip4Err ? constantMessageData.ZIP4_REQUIRED : null
                        }
                        error={
                          showZip4Err ? constantMessageData.ZIP4_REQUIRED : null
                        }
                      />
                    </div>
                  </div>
                </div>

                <div className='line-break-div' />

                <div className='mui-custom-form input-md'>
                  <div className='row'>
                    <div className='col-sm-7 '>
                      <TextField
                        id='phoneNum'
                        label={
                          windowWidth >= 745 ? 'Phone Number' : 'Phone No.'
                        }
                        data-testid='phone'
                        className='mandate-fields'
                        disabled={isReadOnly || !isEnablebyRole || isSystemParameter}
                        fullWidth
                        placeholder=''
                        inputProps={{ maxLength: 10 }}
                        InputLabelProps={{
                          shrink: true,
                        }}
                        value={selectRowData && selectRowData.phoneNum}
                        onChange={(e) => {
                          handleOnChangeEvent(e, 'phoneNum');
                        }}
                        onBlur={(e) => {
                          props.handleOnBlurEvent(e, 'phoneNum');
                        }}
                        helperText={
                          showPhoneErr ||
                          (errorMessages &&
                            errorMessages.length > 0 &&
                            errorMessages.filter((x) => {
                              return x.includes(
                                constantMessageData.PHONE_INVALID_ERROR
                              );
                            }).length > 0)
                            ? constantMessageData.PHONE_INVALID_ERROR
                            : null
                        }
                        error={
                          showPhoneErr ||
                          (errorMessages &&
                            errorMessages.length > 0 &&
                            errorMessages.filter((x) => {
                              return x.includes(
                                constantMessageData.PHONE_INVALID_ERROR
                              );
                            }).length > 0)
                            ? constantMessageData.PHONE_INVALID_ERROR
                            : null
                        }
                      />
                    </div>
                    <div className='col-sm-5 pl-0'>
                      <TextField
                        id='Extension'
                        label='Extension'
                        data-testid='Extension'
                        disabled={isReadOnly || !isEnablebyRole || isSystemParameter}
                        fullWidth
                        placeholder=''
                        inputProps={{ maxLength: 6 }}
                        InputLabelProps={{
                          shrink: true,
                        }}
                        value={selectRowData && selectRowData.phoneExtension}
                        onChange={(e) => {
                          handleOnChangeEvent(e, 'phoneExtension');
                        }}
                      />
                    </div>
                  </div>
                </div>
                <div className='mui-custom-form input-md'>
                  <TextField
                    id='faxNum'
                    label='Fax Number'
                    data-testid='fax'
                    disabled={isReadOnly || !isEnablebyRole || isSystemParameter}
                    fullWidth
                    placeholder=''
                    inputProps={{ maxLength: 10 }}
                    InputLabelProps={{
                      shrink: true,
                    }}
                    value={selectRowData && selectRowData.faxNum}
                    onChange={(e) => {
                      handleOnChangeEvent(e, 'faxNum');
                    }}
                  />
                </div>
                <div className='mui-custom-form input-md'>
                  <TextField
                    id='emailAddr'
                    label='Email Address'
                    className='mandate-fields'
                    data-testid='email'
                    disabled={isReadOnly || !isEnablebyRole || isSystemParameter}
                    fullWidth
                    placeholder=''
                    inputProps={{ maxLength: 50 }}
                    InputLabelProps={{
                      shrink: true,
                    }}
                    value={selectRowData && selectRowData.emailAddr}
                    onChange={(e) => {
                      handleOnChangeEvent(e, 'emailAddr');
                    }}
                    onBlur={(e) => {
                      props.handleOnBlurEvent(e, 'emailAddr');
                    }}
                    helperText={
                      showEmailErr ||
                      (errorMessages &&
                        errorMessages.length > 0 &&
                        errorMessages.filter((x) => {
                          return x.includes(constantMessageData.EMAIL_INVALID);
                        }).length > 0)
                        ? constantMessageData.EMAIL_INVALID
                        : null
                    }
                    error={
                      showEmailErr ||
                      (errorMessages &&
                        errorMessages.length > 0 &&
                        errorMessages.filter((x) => {
                          return x.includes(constantMessageData.EMAIL_INVALID);
                        }).length > 0)
                        ? constantMessageData.EMAIL_INVALID
                        : null
                    }
                  />
                </div>
              </div>
            </fieldset>
          </div>
        </form>
      </div>
    </div>
  );
}

export default CommentAddressInfoTab;
